var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrokenLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Product card/Broken link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Product-card/Broken-link",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LinkBreak",
    transform: "translate(-0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 21.3333333,
    height: 21.3333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.0082925,
    y1: 6,
    x2: 8.0082925,
    y2: 4,
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3416258,
    y1: 17.3333333,
    x2: 13.3416258,
    y2: 15.3333333,
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.99995917,
    y1: 8.00833333,
    x2: 3.99995917,
    y2: 8.00833333,
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.3332925,
    y1: 13.3416667,
    x2: 15.3332925,
    y2: 13.3416667,
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91912,10.7001667 L4.97631083,11.6429775 C3.67522316,12.9448382 3.6755365,15.0548483 4.97701076,16.3563226 C6.27848503,17.6577968 8.38849509,17.6581102 9.69035583,16.3570225 L10.6331667,15.4142133",
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4142133,10.6331667 L16.3570225,9.6903575 C17.6581102,8.38849675 17.6577968,6.2784867 16.3563226,4.97701243 C15.0548483,3.67553816 12.9448382,3.67522483 11.6429775,4.9763125 L10.7001667,5.91912",
    id: "Path",
    stroke: "#D23778",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrokenLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broken-link.73d484847747f58978c045dd38a35f34.svg";